/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { EventControllerGetEventsParams, GetDetailEventDtoRx, GetEventReceptionDtoRx } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class EventApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Event API
   * @name EventControllerGetEvents
   * @summary 이벤트 목록 조회
   * @request GET:/api/event
   * @secure
   */
  eventControllerGetEvents = (query: EventControllerGetEventsParams, params: RequestParams = {}) =>
    this.request<GetEventReceptionDtoRx, any>({
      path: `/api/event`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Event API
   * @name EventControllerGetEvent
   * @summary 이벤트 상세 조회
   * @request GET:/api/event/{id}
   * @secure
   */
  eventControllerGetEvent = (id: number, params: RequestParams = {}) =>
    this.request<GetDetailEventDtoRx, any>({
      path: `/api/event/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
